import "clsx";
import { F as FAQ } from "../../../../../chunks/FAQ.js";
function _page($$renderer) {
  FAQ($$renderer);
}
export {
  _page as default
};
